"use client";
import * as React from "react";
import { useState } from "react";

function BussinessOutsource() {
  const [hoveredCard, setHoveredCard] = useState(null);

  const outsourcingData = [
    {
      id: 1,
      title: "Business Process Outsource",
      content: `Vasta Business process outsourcing (BPO) is a valuable strategy for its Stakeholders who are seeking new ways to achieve high performance by controlling costs, reducing risk, fostering collaboration and increasing transparency. Our BPO Services on Back Office outsourcing - which includes internal business functions such as human resources or finance and accounting, and Front Office outsourcing - which includes customer-related services such as contact center services.`,
      titleColor: "bg-blue-500",
      cardColor: "bg-blue-50",
    },
    {
      id: 2,
      title: "Knowledge Process Outsource",
      content: `Vasta Knowledge Process Outsourcing (KPO) describes the outsourcing of core information which based on business activities. Our KPO (Knowledge Process Outsourcing) services include , All kinds of research and information gathering, e.g. intellectual property research for patent applications; equity research, business and market research, legal and medical services; training, consultancy, and research and development in fields such as pharmaceuticals and biotechnology; and animation and design.`,
      titleColor: "bg-indigo-500",
      cardColor: "bg-indigo-50",
    },
    {
      id: 3,
      title: "Recruitment Process Outsource",
      content: `Vasta Recruitment Process Outsourcing is a part of Business Process Outsourcing and here we transfers all or part of our Clients recruitment activities. By using our RPO services our client manage entire recruiting and hiring process from job profiling up to on-boarding of the new hire. We provide RPO Services which covers Employment Marketing, Brand Creation , Candidate Sourcing , Screening , Interview Scheduling , Offer Administration , Verification and Pre-Employment Check , On-Boarding , On-Site Services , Reporting and Analysis and Exit Formalities.`,
      titleColor: "bg-purple-500",
      cardColor: "bg-purple-50",
    },
  ];

  // Outsourcing Card Component
  const OutsourcingCard = ({ service, index, onHover, onLeave, isHovered }) => {
    const floatingAnimation = {
      animation: `outsourcingFloat-${index} 4s ease-in-out infinite`,
      animationDelay: `${index * 0.3}s`,
    };

    return (
      <div
        className={`
          relative bg-white rounded-2xl shadow-xl transform transition-all duration-500 ease-out
          hover:scale-105 hover:-translate-y-2 border border-slate-100 overflow-hidden
          ${isHovered ? "shadow-2xl scale-105" : ""}
        `}
        style={floatingAnimation}
        onMouseEnter={() => onHover(service.id)}
        onMouseLeave={onLeave}
        role="article"
        aria-labelledby={`outsourcing-title-${service.id}`}
        tabIndex={0}
      >
        {/* Title section with colored background */}
        <div className={`${service.titleColor} px-6 py-4`}>
          <h3
            id={`outsourcing-title-${service.id}`}
            className="text-xl font-bold text-white leading-tight"
          >
            {service.title}
          </h3>
        </div>

        {/* Content section */}
        <div className="p-6">
          <div
            className={`${service.cardColor} rounded-xl p-4 border border-slate-100`}
          >
            <p className="text-slate-700 text-sm leading-relaxed">
              {service.content}
            </p>
          </div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-br from-white via-transparent to-slate-50 rounded-2xl pointer-events-none opacity-20"></div>
      </div>
    );
  };

  // Decorative Dots Component
  const DecorativeDots = ({ position, color = "blue" }) => {
    const dots = [];
    const baseSize = position === "top-right" ? 6 : 8;
    const dotCount = position === "top-right" ? 15 : 20;

    for (let i = 0; i < dotCount; i++) {
      const size = Math.max(2, baseSize - i * 0.3);
      const opacity = Math.max(0.1, 0.8 - i * 0.04);
      const offset = i * (position === "top-right" ? 12 : 15);

      dots.push(
        <div
          key={i}
          className={`absolute w-${Math.ceil(size / 4)} h-${Math.ceil(size / 4)} bg-${color}-400 rounded-full`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            opacity: opacity,
            ...(position === "top-right"
              ? { top: `${offset}px`, right: `${offset}px` }
              : { bottom: `${offset}px`, left: `${offset}px` }),
          }}
        />,
      );
    }

    return (
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {dots}
      </div>
    );
  };

  return (
    <>
      <style>{`
        @keyframes outsourcingFloat-0 {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
        }
        @keyframes outsourcingFloat-1 {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes outsourcingFloat-2 {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-5px); }
        }

        .paper-texture {
          background-image:
            radial-gradient(circle at 1px 1px, rgba(99, 102, 241, 0.03) 1px, transparent 0);
          background-size: 20px 20px;
        }

        .board-shadow {
          box-shadow:
            0 25px 50px -12px rgba(99, 102, 241, 0.25),
            0 0 0 1px rgba(255, 255, 255, 0.05),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }
      `}</style>

      {/* Outsourcing Section */}
      <section
        className="min-h-screen bg-gradient-to-br from-[#edf4ff] via-purple-50/30 to-pink-50/40 relative overflow-hidden py-8 lg:py-16"
        aria-labelledby="outsourcing-heading"
      >
        {/* Background decorative elements */}
        <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
          <div className="absolute top-1/3 right-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-purple-200/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/3 left-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-pink-200/20 rounded-full blur-3xl"></div>
        </div>

        {/* Decorative dots */}
        <DecorativeDots position="top-right" color="purple" />
        <DecorativeDots position="bottom-left" color="pink" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
          {/* Header */}
          <header className="text-center mb-8 lg:mb-16">
            <div className="inline-flex items-center px-4 lg:px-6 py-2 bg-gradient-to-r from-indigo-600 to-blue-600 backdrop-blur-md border border-purple-600/60 rounded-full mb-4 lg:mb-3 shadow-lg">
              <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
              <span className="text-xs lg:text-sm text-white font-semibold uppercase tracking-wider">
                Outsourcing Services
              </span>
            </div>
            <h1
              id="features-heading"
              className="text-5xl lg:text-6xl font-black mb-8 tracking-tight"
              style={{ color: "#1E293B" }}
            >
              <span
                className="block leading-snug  bg-gradient-to-r bg-clip-text text-transparent"
                style={{
                  backgroundImage:
                    "linear-gradient(135deg, #1719A8 0%, #D96F2B 50%, #C9C51A 100%)",
                }}
              >
                Bussiness Outsourcing
              </span>
              Solutions for Every Department
            </h1>

            <p className="text-slate-600 mt-4 text-base lg:text-lg max-w-3xl mx-auto leading-relaxed px-4">
              Comprehensive outsourcing services designed to optimize your
              business operations and enhance efficiency across all departments.
            </p>
          </header>

          {/* Outsourcing Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {outsourcingData.map((service, index) => (
              <OutsourcingCard
                key={service.id}
                service={service}
                index={index}
                onHover={setHoveredCard}
                onLeave={() => setHoveredCard(null)}
                isHovered={hoveredCard === service.id}
              />
            ))}
          </div>

          {/* Decorative elements */}
          <div className="absolute top-8 left-8 w-4 h-4 bg-purple-400 rounded-full opacity-60"></div>
          <div className="absolute bottom-8 right-8 w-3 h-3 bg-pink-400 rounded-full opacity-60"></div>
          <div className="absolute top-1/3 left-16 w-2 h-2 bg-indigo-400 rounded-full opacity-60"></div>
        </div>
      </section>
    </>
  );
}

export default BussinessOutsource;
